const circleSize = 50;
const styles: Record<string, React.CSSProperties> = {
  container: {
    alignItems: "center",
    paddingTop: 20,
    paddingBottom: 20,
  },
  carouselScroll: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 10,
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    paddingLeft: 10,
    paddingRight: 10,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
  },
  dayName: {
    fontSize: 14,
    color: "#888",
    marginBottom: 5,
  },
  dayNameSelected: {
    color: "#fff",
  },
  dayCircle: {
    width: circleSize,
    height: circleSize,
    borderRadius: circleSize / 2,
    backgroundColor: "#444",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dayCircleSelected: {
    backgroundColor: "#00b894",
  },
  dayNumber: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
  },
  registerButton: {
    marginTop: 20,
    padding: 16,
    backgroundColor: "#ff9f43",
    borderRadius: 8,
    width: "100%",
  },
  registerButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
  },
};

export default styles;
